import React from "react";
import Testimonials from "../home/Testimonials";

const ReviewTestimonials = () => {
  return <Testimonials />;
};

export default ReviewTestimonials;
